import { Box, IconButton } from "@mui/material";
import React, { useState, useEffect } from "react";
import ValidatedTextFieldPassenger from "./ValidatedTextFieldPassenger";
import CloseIcon from "@mui/icons-material/Close";
import { textValidator } from "../../helpers/validators/input-validators";

const CreatePassengerItem = ({
  index,
  name: nameProp,
  address: addressProp,
  flight: flightProp,
  contactTel: contactTelProp,
  setState,
  passengersState,
  age,
  setAgesState,
  setPassengersState,
  onUpdate,
  onDelete,
}) => {
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [flight, setFlight] = useState("");
  const [contactTel, setContactTel] = useState("");

  useEffect(() => {
    setName(nameProp);
    setAddress(addressProp);
    setFlight(flightProp);
    setContactTel(contactTelProp);
  }, [nameProp, addressProp, flightProp, contactTelProp]);

  const fields = [
    { value: name, setValue: setName, label: "Ime i prezime", field: "name" },
    { value: address, setValue: setAddress, label: "Adresa", field: "address" },
    { value: flight, setValue: setFlight, label: "Let", field: "flight" },
    { value: contactTel, setValue: setContactTel, label: "Kontakt telefon", field: "contactTel" },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: { xs: "wrap", md: "nowrap" }, // prelamanje samo na mobilnom
        alignItems: "center",
        gap: 1,
        p: 1,
        borderRadius: 2,
        backgroundColor: "#f9fafb",
      }}
    >
      {fields.map((item, idx) => (
        <Box
          key={idx}
          sx={{
            flex: { xs: "1 1 100%", md: "1 1 0" }, // puni red na mobilnom, proporcionalno na desktopu
            minWidth: 0,
          }}
        >
          <ValidatedTextFieldPassenger
            value={item.value}
            setValue={item.setValue}
            label={item.label}
            validator={textValidator}
            fullWidth
            type="text"
            age={age}
            fieldName={item.field}
            onUpdate={(fieldName, newValue) => onUpdate(index, fieldName, newValue, setState)}
          />
        </Box>
      ))}

      <Box sx={{ flexShrink: 0 }}>
        <IconButton
          onClick={() => onDelete(index, passengersState, setAgesState, setPassengersState)}
          sx={{
            color: "#ef4444",
            "&:hover": { backgroundColor: "#fee2e2" },
            mt: { xs: 1, md: 0 },
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default CreatePassengerItem;
